import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { useAuth } from '../../AuthContext/AuthContext';
import LoginForm, { AdminLoginInput } from './LoginForm/LoginForm';
import useNotifications from '../../Notifications/useNotifications';
import { useUserDetails } from '../../UserContext/UserContex';
import { useLoginLazyQuery } from './graphql/login.generated';

const picture = require('./logo.png');

const Login = () => {
  const { login } = useAuth();
  const [fetchLogin, { loading, error }] = useLoginLazyQuery();
  const { addError, addSuccess } = useNotifications();
  const { setUser: setUserName } = useUserDetails();

  const submitLogin = async (values: AdminLoginInput) => {
    const result = await fetchLogin({ variables: { input: values } });

    const data = result.data?.login;

    console.log(data);
    addSuccess('You logged in successfully');
    setUserName(data?.firstName || '', data?.lastName || '', data?.id || '', data?.permissions || {});
    login(data?.token || '');
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    addError('An error occoured during login');
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '75%',
        margin: 'auto'
      }}
    >
      <img style={{ paddingTop: '2rem' }} src={picture} />
      <LoginForm onSubmit={submitLogin} />
    </div>
  );
};

export default Login;
